import foto from "../images/foto.jpg";

export const user ={
  name: 'Александр',
  avatar: `${foto}`,
  firstName: 'Белов',
  status: 'online',
  phone: '+7(495)9999999',
  patronymic: 'Иванович',
  email: 'email@gmail.com'
}